import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from "@angular/core";
import { AutoStakingFacade } from "@modules/staking/domain/+state/auto-staking.facade";
import { UniversalModalService } from "@modules/+new/shared/universal-modal/universal-modal.service";
import { ModalCloseReason } from "@modules/+new/shared/universal-modal/entities/modal-close-reason.enum";
import { CdkTrapFocus } from "@angular/cdk/a11y";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { TranslationService } from "@core-services/translation.service";
import { InfoService } from "@core-services/info.service";
import { AutoStakingTrackingFacade } from "@modules/staking/domain/+state/auto-staking-tracking.facade";
import { CoreModule } from "@modules/core/core.module";
import { DarkModeService } from "@core-services/dark-mode.service";

@Component({
	selector: "app-auto-staking-cancel",
	standalone: true,
	imports: [CdkTrapFocus, TranslationPipeModule, UniversalModalModule, CoreModule],
	templateUrl: "./auto-staking-cancel.component.html",
	styleUrl: "./auto-staking-cancel.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoStakingCancelComponent implements OnInit {
	private readonly autoStakingFacade = inject(AutoStakingFacade);
	private readonly universalModalService = inject(UniversalModalService);
	private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
	private readonly translationService = inject(TranslationService);
	private readonly infoService = inject(InfoService);
	private readonly autoStakingTrackingFacade = inject(AutoStakingTrackingFacade);
	protected readonly darkModeService = inject(DarkModeService);

	public apiLoading = false;

	public ngOnInit(): void {
		this.autoStakingTrackingFacade.trackEvent("Auto Staking Setting Screen Viewed");
	}

	closeModal(): void {
		this.universalModalService.close(ModalCloseReason.close);
	}

	cancelAutoStaking(): void {
		this.apiLoading = true;
		this.autoStakingFacade.setAutoStakingState(false).subscribe({
			next: () => {
				this.apiLoading = false;
				this.autoStakingTrackingFacade.trackEvent("Auto Staking Setting Changed ", { opt_in: false });
				this.infoService.setSuccess(this.translationService.translate("auto_staking_off_success_toast"));
				this.cdr.markForCheck();
				this.closeModal();
			},
			error: () => {
				this.apiLoading = false;
				this.cdr.markForCheck();
			}
		});
	}
}
